import React from 'react'
import Login from 'src/containers/Login'

function LoginPage() {
	return <Login />
}

export default React.memo(LoginPage)
